<template>
<div>
  <el-card body-style="padding: 0">
    <el-form ref="queryForm" :model="queryForm" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="业务员" prop="businessName">
            <el-input v-model="queryForm.businessName" placeholder="请输入业务员"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="上一级业务员" prop="upBusinessUser">
            <el-input v-model="queryForm.upBusinessUser" placeholder="请输入上一级业务员"/>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="分站" prop="ownerWeb">
            <el-input v-model="queryForm.ownerWeb" placeholder="请输入分站信息"/>
          </el-form-item>
        </el-col>
      </el-row>
     <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="业务类别" prop="businessType">
            <el-select v-model="queryForm.businessType" clearable placeholder="请选择业务类型">
              <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="6">
          <el-form-item>
            <el-button type="primary" size="small"
                       @click="submitQueryForm()" icon="el-icon-search">
              查询</el-button>
            <el-button type="primary" size="small" plain
                       @click="resetQueryForm()" icon="el-icon-refresh">
              重置</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-card>

  <el-card>
    <el-button v-show="isShowAccessField(8)" type="primary" size="mini" plain style="margin: 0 0 10px 20px"
               @click="handleAddSaleman">新增</el-button>
    <el-button type="success" size="mini" plain style="margin: 0 0 10px 20px"
               @click="reflushData">刷新</el-button>
    <el-button v-show="isShowAccessField(9)" type="primary" size="mini" style="margin: 0 0 10px 20px"
               @click="handleImportData('导入用户数据')">导入业务员</el-button>
    <el-table :data="tableData"
              ref="table"
              border default-expand-all stripe
              :header-cell-style="{'text-align':'center'}"
              :max-height="tableHeight"
              style="width: 100%;margin-bottom: 20px;"
              :cell-style="{'text-align':'center'}"
              @selection-change="handleSelectionChange">
      <el-table-column label="全选" width="50" type="selection"/>
      <el-table-column prop="businessId" label="编号" width="180" >
        <!--<template slot-scope="scope" >
          <span style="text-align: center">{{getStrEndWithNumbers(scope.row.businessId)}}</span>
        </template>-->
      </el-table-column>
      <el-table-column prop="businessName" label="业务员" />
      <el-table-column prop="ownerWeb" label="所属分站" />
      <el-table-column prop="upBusinessUser" width="100" label="上级业务员" />
      <el-table-column prop="balanceMoney" label="余额" />
      <el-table-column prop="freeMoney" label="冻结" />
      <el-table-column prop="commissionMoneyRate" width="120" label="抽佣比例">
        <template slot-scope="scope">
          <span v-html="scope.row.commissionMoneyRate"></span>
        </template>
      </el-table-column>
      <el-table-column prop="shareCode" label="分享码" />
      <el-table-column prop="createTime" width="100" label="添加时间" />
      <el-table-column prop="isEnableUsed" label="是否启用">
        <template slot-scope="scope">
          <span style="color: #1F9FFF">{{scope.row.isEnableUsed?"启用":"未启用"}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="remarks" label="备注" />
      <el-table-column label="操作" width="340" align="center">
        <template slot-scope="scope">
          <el-row>
            <el-col :span="24">
              <el-button v-show="isShowAccessField(10)" size="mini" type="primary" plain
                         @click="handleComEdit(scope.$index, scope.row,'修改')">
                设置
              </el-button>
              <el-button v-show="isShowAccessField(11)" size="mini" type="success" plain
                         @click="handleBusinessSetting(scope.$index, scope.row, '业务配置')">
                业务配置
              </el-button>
              <el-button size="mini" type="danger" plain v-if="scope.row.isEnableUsed"
                         @click="unEnableUser(scope.$index, scope.row)">
                禁用
              </el-button>
              <el-button size="mini" type="primary" plain v-else
                         @click="unEnableUser(scope.$index, scope.row)">
                开启
              </el-button>
              <el-button size="mini" type="primary" plain
                         @click="reflushShareCode(scope.$index, scope.row)">
                刷新邀请码
              </el-button>
            </el-col>
          </el-row>
          <el-row style="margin-top: 10px;">
            <el-col :span="24">
              <el-button v-show="isShowAccessField(12)" size="mini" type="primary" plain
                         @click="resetPwd(scope.$index, scope.row)">
                重置密码
              </el-button>
              <el-button v-show="isShowAccessField(13)" size="mini" type="primary" plain
                         @click="handleOpenWeb(scope.$index, scope.row)">
                {{openWebButtonTitle(scope.row.isEnableWeb)}}
              </el-button>
              <el-button v-show="isShowAccessField(14)" size="mini" type="primary" plain
                         @click="handleLoginSaleman(scope.$index, scope.row)">
                登录
              </el-button>
            </el-col>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        :page-sizes="[20, 50, 100, 200]"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @size-change="handlePageSizeChange"
        @current-change="handlePageNumChange"
        background
        style="float: right;margin-bottom: 10px">
    </el-pagination>
  </el-card>

  <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
    <el-form ref="dialogForm" :model="dialogForm" label-width="220px">
      <el-form-item label="业务员">
        <el-input v-model="dialogForm.businessName" style="width: 50%;" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="分享权限">
        <el-radio-group v-model="dialogForm.shareLimit">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">不限</el-radio>
          <el-radio :label="2">试客</el-radio>
          <el-radio :label="3">商家</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商家业务抽佣">
        <el-input v-model="dialogForm.businessCommission" style="width: 30%;" size="mini"></el-input>
        <span>%<span style="margin-left:1%; color: red">(注：商家订单完成后，给予业务员的点数)</span></span>
      </el-form-item>
      <el-form-item label="试客业务抽佣">
        <el-input v-model="dialogForm.customerCommission" style="width: 30%;" size="mini"></el-input>
        <span>%<span style="margin-left:1%; color: red">(注：试客订单完成后，给予业务员的点数)</span></span>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitDialogForm()" size="mini" type="primary">提交</el-button>
      <el-button @click="handleCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>

  <el-dialog :title="dialogBusinessTitle" :visible.sync="dialogBusinessFormVisible">
    <el-form ref="dialogBusinessForm" :model="dialogBusinessForm" label-width="220px">
      <div v-for="(item, index) in businessCommissionMoneyLimits" :key="index">
      <div style="border-bottom: 1px solid #04befe" v-if="item.shareUser == 0">
        <span style="color: #409EFF">商家业务员（所招商家，完成一单可得多少）</span>
      </div>
        <div style="border-bottom: 1px solid #04befe" v-else>
          <span style="color: #409EFF">试客业务（所招试客，完成一单可得多少）</span>
        </div>
      <el-form-item label="手机淘宝任务">
        <el-input v-model="item.taobaoTask" style="width: 50%;" size="mini"></el-input>
        <span>(元)</span>
      </el-form-item>
      <el-form-item label="手机淘宝淘口令">
        <el-input v-model="item.taobaoTaoCommand" style="width: 50%;" size="mini"></el-input>
        <span>(元)</span>
      </el-form-item>
      <el-form-item label="手机淘宝无截图版">
        <el-input v-model="item.taobaoCaptureTask" style="width: 50%;" size="mini"></el-input>
        <span>(元)</span>
      </el-form-item>
      <el-form-item label="手淘隔天任务">
        <el-input v-model="item.taobaoDayTask" style="width: 50%;" size="mini"></el-input>
        <span>(元)</span>
      </el-form-item>
      <el-form-item label="手机淘宝淘口令裂变">
        <el-input v-model="item.taobaoCommandFission" style="width: 50%;" size="mini"></el-input>
        <span>(元)</span>
      </el-form-item>
      <el-form-item label="手淘聚划算">
        <el-input v-model="item.taobaoJuhuasuanTask" style="width: 50%;" size="mini"></el-input>
        <span>(元)</span>
      </el-form-item>
      <el-form-item label="手机拼多多">
        <el-input v-model="item.pinduoduoTask" style="width: 50%;" size="mini"></el-input>
        <span>(元)</span>
      </el-form-item>
      <el-form-item label="拼多多二维码任务">
        <el-input v-model="item.pinduoduoQrcode" style="width: 50%;" size="mini"></el-input>
        <span>(元)</span>
      </el-form-item>
      <el-form-item label="手机京东">
        <el-input v-model="item.jdTask" style="width: 50%;" size="mini"></el-input>
        <span>(元)</span>
      </el-form-item>
      <el-form-item label="京喜">
        <el-input v-model="item.jxiTask" style="width: 50%;" size="mini"></el-input>
        <span>(元)</span>
      </el-form-item>
      <el-form-item label="手机阿里巴巴任务">
        <el-input v-model="item.alibabaTask" style="width: 50%;" size="mini"></el-input>
        <span>(元)</span>
      </el-form-item>
      <el-form-item label="抖音小店任务">
        <el-input v-model="item.dyStoreTask" style="width: 50%;" size="mini"></el-input>
        <span>(元)</span>
      </el-form-item>
      <el-form-item label="洋淘">
        <el-input v-model="item.yangtaoTask" style="width: 50%;" size="mini"></el-input>
        <span>(元)</span>
      </el-form-item>
      <el-form-item label="淘宝直播任务">
        <el-input v-model="item.taobaoVideo" style="width: 50%;" size="mini"></el-input>
        <span>(元)</span>
      </el-form-item>
      <el-form-item label="淘宝二维码任务">
        <el-input v-model="item.taobaoQrcode" style="width: 50%;" size="mini"></el-input>
        <span>(元)</span>
      </el-form-item>
      <el-form-item label="手机浏览单">
        <el-input v-model="item.phoneWebsit" style="width: 50%;" size="mini"></el-input>
        <span>(元)</span>
      </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitDialogBusinessForm()" size="mini" type="primary">提交</el-button>
      <el-button @click="handleBusinessCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>

  <el-dialog :title="dialogImportDataTitle" :visible.sync="dialogImportDataFormVisible">
    <el-form ref="dialogImportDataForm" :model="dialogImportDataForm" label-width="220px">
      <el-row :gutter="20">
        <el-col :span="24" style="text-align: center">
          <el-link target="_blank" href="https://myb2c.oss-cn-hangzhou.aliyuncs.com/dataimporttemplate/salemanTemplate.xlsx" :underline="false">
            <el-button style="margin-bottom: 2%;" type="primary" plain >下载模版</el-button>
          </el-link>
          <div style="color: red;max-width: 90%;margin-left:2%;text-align: center;">
            <span>模版为业务员信息导入模版。如果增加其他角色，请联系管理</span>
            <div> 如果有上下级关系， 请先导入最上级用户。切记</div>
          </div>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row :gutter="20">
        <el-col :span="24" style="text-align: center;">
          <el-upload
              class="avatar-uploader"
              drag
              action="https://api.weiquanai.com/b2cmanagepersons/saleman/upload"
              :headers="myheader"
              :show-file-list="false"
              accept=".xlsx"
              :before-upload="onbeforeunloads"
              :on-success="importDataSuccess"
              :on-error="importDataError">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击导入</em></div>
            <div class="el-upload__tip" slot="tip">只能上传.xlsx文件，且不超过50MB</div>
          </el-upload>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>

  <el-dialog :title="dialogAddSalemanTitle" :visible.sync="dialogAddSalemanFormVisible">
    <el-form ref="dialogAddSalemanForm" :model="dialogAddSalemanForm" label-width="220px">
      <!--<el-form-item label="业务员">
        <el-input v-model="dialogAddSalemanForm.businessName" style="width: 50%;" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="分享权限">
        <el-radio-group v-model="dialogAddSalemanForm.shareLimit">
          <el-radio :label="0">关闭</el-radio>
          <el-radio :label="1">不限</el-radio>
          <el-radio :label="2">试客</el-radio>
          <el-radio :label="3">商家</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="商家业务抽佣">
        <el-input v-model="dialogAddSalemanForm.businessCommission" style="width: 30%;" size="mini"></el-input>
        <span>%<span style="margin-left:1%; color: red">(注：商家订单完成后，给予业务员的点数)</span></span>
      </el-form-item>
      <el-form-item label="试客业务抽佣">
        <el-input v-model="dialogAddSalemanForm.customerCommission" style="width: 30%;" size="mini"></el-input>
        <span>%<span style="margin-left:1%; color: red">(注：试客订单完成后，给予业务员的点数)</span></span>
      </el-form-item>-->
      <el-form-item label="业务员用户名">
        <el-input v-model="dialogAddSalemanForm.userName" style="width: 50%;" size="mini"></el-input>
      </el-form-item>
      <el-form-item label="业务员手机号">
        <el-input v-model="dialogAddSalemanForm.userPhone" style="width: 50%;" size="mini"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="submitAddSalemanDialogForm()" size="mini" type="primary">提交</el-button>
      <el-button @click="handleAddSalemanCloseDialog" size="mini">取 消</el-button>
    </div>
  </el-dialog>
</div>
</template>

<script>
import MixinCUD from '@/components/MixinCUD'
import {
  getBusiness, getCommission, getCommissionMoney,
  setCommission,
  setCommissionMoney, updateBusinessWebEnable
} from "../../api/b2cbusiness/storelist";
import {getJwtToken, getStrEndWithNumbers} from "../../lib/utils";
import {changeUserUsed, queryAdminLoginUser} from "../../api/b2cbusiness/b2c_customerinfo";
import {addUser, resetUserPwd} from "../../api/system/sys_user";
import {reflushShareCode} from "../../api/b2cbusiness/b2c_sharecode";
import {Loading} from "element-ui";
import {queryRoleAccessField} from "@/api/system/sys_role";
import MinxinScroll from "@/components/MinxinScroll";
export default {
  name: "BusinessManagelist",
  mixins:[MixinCUD, MinxinScroll],
  data(){
    return {
      myheader: {
        JWTHeaderName: ""
      },
      tableData:[],
      queryFormRefName:"queryForm",
      queryForm:{
        businessName: '',
        upBusinessUser: '',
        ownerWeb: '',
        businessType: '',
      },
      options:[
        {
          value: "总站业务员"
        },
        {
          value: "分站业务员"
        },
        {
          value: "分站"
        }
      ],
      dialogFormVisible: false,
      dialogTitle: "",
      dialogRefName: "dialogForm",
      dialogForm:{
      },
      dialogAddSalemanFormVisible: false,
      dialogAddSalemanTitle: "",
      dialogAddSalemanRefName: "dialogAddSalemanForm",
      dialogAddSalemanForm:{
      },
      dialogBusinessFormVisible: false,
      dialogBusinessTitle: "",
      dialogBusinessRefName: "dialogBusinessForm",
      dialogBusinessForm:{

      },
      dialogImportDataFormVisible: false,
      dialogImportDataTitle: "导入用户数据",
      dialogImportDataRefName: "dialogImportDataForm",
      dialogImportDataForm:{
      },
      businessCommissionMoneyLimits:[
        {
          b2cUsersId:"",
          shareUser:0,
          taobaoTask:0,
          taobaoTaoCommand:0,
          taobaoCaptureTask:0,
          taobaoDayTask:0,
          taobaoCommandFission:0,
          taobaoJuhuasuanTask:0,
          pinduoduoTask:0,
          pinduoduoQrcode:0,
          jdTask:0,
          jxiTask:0,
          alibabaTask:0,
          dyStoreTask:0,
          yangtaoTask:0,
          taobaoVideo:0,
          taobaoQrcode:0,
          phoneWebsit:0,
        },
        {
          b2cUsersId:"",
          shareUser:1,
          taobaoTask:0,
          taobaoTaoCommand:0,
          taobaoCaptureTask:0,
          taobaoDayTask:0,
          taobaoCommandFission:0,
          taobaoJuhuasuanTask:0,
          pinduoduoTask:0,
          pinduoduoQrcode:0,
          jdTask:0,
          jxiTask:0,
          alibabaTask:0,
          dyStoreTask:0,
          yangtaoTask:0,
          taobaoVideo:0,
          taobaoQrcode:0,
          phoneWebsit:0,
        }
      ],
      loadingInstance:null,
      tableHeight: 850,
      pagination:{
        pageNum: 1,
        pageSize: 20,
        total: null
      },
      b2cAccessFieldInfos: []
    }
  },
  created() {
    this.tableHeight = document.documentElement.clientHeight - 320;
    //console.log(document.body.clientHeight, this.tableHeight)
  },
  mounted() {
    //this.tableHeight = document.body.clientHeight - 220;
    this.myheader.JWTHeaderName = getJwtToken();
    this.getData();
    /*获取字段权限*/
    queryRoleAccessField("业务员管理", null).then(res => {
      if (res.success){
        this.b2cAccessFieldInfos = res.data;
        //console.log(this.b2cAccessFieldInfos)
      }
    }).catch(err => {
      this.$message({message: err.message, type: 'error'});
    });
  },
  computed:{
    isShowAccessField(){
      return function (fieldId) {
        if (this.b2cAccessFieldInfos.length <= 0){
          return false;
        }else{
          return this.b2cAccessFieldInfos.filter(item => item.id == fieldId).length > 0;
        }
      }
    },
    openWebButtonTitle(){
      return function (b) {
        if (!b){
          return "开启分站"
        }else{
          return "分站配置"
        }
      }
    }
  },
  methods: {
    onbeforeunloads(file){
      this.loadingInstance = Loading.service({text:"上传处理中"});
    },
    importDataSuccess(res, file){
      console.log(res, file);
      if (res.success){
        this.$message.success("导入数据成功");
        this.loadingInstance.close();
        this.dialogImportDataFormVisible = false;
        this.getData();
        this.$forceUpdate();
      }
    },
    importDataError(err, file, fileList){
      this.$message({message: err.message, type: 'error'});
      this.loadingInstance.close();
    },
    handleAddSaleman(){
      this.dialogAddSalemanFormVisible = true;
      this.dialogAddSalemanTitle = "添加业务员"
    },
    submitAddSalemanDialogForm(){
      this.dialogAddSalemanForm.userType = "业务员";
      this.dialogAddSalemanForm.roleCode = "salesman";
      addUser(this.dialogAddSalemanForm).then(res=>{
        if (res.success){
          this.$message.success("添加成功，初始密码:abce1234");
          this.dialogAddSalemanFormVisible = false;
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
        this.dialogAddSalemanFormVisible = false;
      });
    },
    handleAddSalemanCloseDialog(){
      this.$refs[this.dialogAddSalemanRefName].resetFields();
      this.dialogAddSalemanFormVisible = false;
    },
    reflushShareCode(index, data){
      this.$confirm("确认刷新分享码？").then(_=>{
        reflushShareCode(data.businessId).then(res=>{
          if (res.success){
            this.$message.success("刷新成功！");
            this.getData();
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      })
    },
    handleLoginSaleman(index, data){
      queryAdminLoginUser({b2cUsersId:data.businessId}).then(res=>{
        if (res.success){
          //this.$router.push({name:'login', params:{userName:res.data.userName, password:res.data.userPassword}});
          window.open("http://dl.usmartdoc.com?username="+res.data.userName+"&password="+res.data.userPassword, "_blank");
          //window.open("https://api.weiquanai.com?username="+res.data.userName+"&password="+res.data.userPassword, "_blank");
        }
      });
    },
    handleImportData(dialogTitle){
      this.dialogImportDataFormVisible = true;
      this.dialogImportDataTitle = dialogTitle
    },
    handleOpenWeb(index, row){
      if (!row.isEnableWeb) {
        this.$confirm("确认开启分站？开启后将不可关闭").then(_ => {
          updateBusinessWebEnable({businessId: row.businessId}).then(res => {
            if (res.success) {
              this.$message({message: res.data, type: 'success'})
              this.getData();
            }
          }).catch(err => {
            this.$message({message: err.message, type: 'error'});
          });
        });
      }else{
        this.$router.push({path:'/home/webconfig', query:{salemanId:row.businessId}})
      }
    },
    resetPwd(index,row){
      this.$confirm("确定重置密码为："
          + this.$store.getters.getSysConfigItem("user.init.password")
          + "么？")
          .then(_ => {
            resetUserPwd(row.businessName).then(res => {
              this.$message({message: res.data, type: 'success'})
            });
          });
    },
    unEnableUser(index ,data){
      changeUserUsed(data.businessId).then(res=>{
        if (res.success){
          this.$message.success("禁止设置信息成功！");
          this.getData();
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    submitDialogBusinessForm(){
      this.$refs[this.dialogBusinessRefName].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交数据么?")
              .then(_ => {
                console.log(this.dialogBusinessForm);
                this.businessCommissionMoneyLimits.forEach(_item=>{
                  _item["b2cUsersId"] = this.dialogBusinessForm.businessId;
                });
                console.log(this.businessCommissionMoneyLimits);
                setCommissionMoney(this.businessCommissionMoneyLimits).then(res=>{
                  if (res.success){
                    this.dialogBusinessFormVisible = false;
                    this.$message.success("更新数据成功！")
                    this.getData();
                  }
                }).catch(err => {
                  this.$message({message: err.message, type: 'error'});
                })
                //取消新增或修改也要重置表单
              }).catch(err => {this.handleCloseDialog();});
        } else {
          return false;
        }
      });
    },
    handleBusinessCloseDialog(){
      this.$refs[this.dialogBusinessRefName].resetFields();
      this.dialogBusinessFormVisible = false;
    },
    handleComEdit(index, row, dialogTitle){
      this.dialogFormVisible = true;
      this.dialogTitle = dialogTitle
      this.resetDialogForm()
      this.dialogForm = {...row}
      getCommission(this.dialogForm).then(res=>{
        if (res.success){
          console.log(this.dialogForm)
          this.dialogForm = {...this.dialogForm, ...res.data};
          console.log(this.dialogForm)
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    handleBusinessSetting(index, data, title){
      this.dialogBusinessFormVisible = true;
      this.dialogBusinessTitle = title
      this.resetDialogBusinessForm()
      this.dialogBusinessForm = {...data}
      getCommissionMoney(this.dialogBusinessForm).then(res=>{
        if (res.success && res.data.length > 0){
          console.log(this.dialogBusinessForm)
          this.businessCommissionMoneyLimits = res.data;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    getStrEndWithNumbers(numbers) {
      return getStrEndWithNumbers(numbers, 8);
    },
    reflushData(){
      this.$confirm("确定刷新数据么?").then(_=>{
        this.tableData = [];
        this.getData();
        this.$forceUpdate();
      })
    },
    getData(){
      this.queryForm.roleCode = "salesman";
      getBusiness(this.queryForm, this.pagination).then(res=>{
        //console.log(res.data)
        if (res.success){
          this.tableData = res.data.records;
          this.pagination.pageNum = res.data.current;
          this.pagination.pageSize = res.data.size;
          this.pagination.total = res.data.total;
        }
        /*
        this.queryForm = {
          businessName: null,
          upBusinessUser: null,
          ownerWeb: null,
          businessType: null
        }

         */
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    },
    updateData(){
      this.dialogForm.b2cUsersId = this.dialogForm.businessId;
      this.dialogForm.createTime = null;
      if (this.dialogForm.businessCommission > 100){
        this.$message.error("抽佣比例不能大于100%");
      }else{
        setCommission(this.dialogForm).then(res=>{
          if (res.success){
            this.dialogFormVisible = false;
            this.$message.success("更新数据成功！");
            this.getData();
          }
        }).catch(err => {
          this.$message({message: err.message, type: 'error'});
        });
      }
    },
    resetDialogBusinessForm(){
      for(let item in this.dialogBusinessForm){
        if (typeof this.dialogBusinessForm[item]==='string'){
          this.dialogBusinessForm[item]='';
        } else if (this.dialogBusinessForm[item] instanceof Array) {
          this.dialogBusinessForm[item]=[];
        } else{
          this.dialogBusinessForm[item]=null
        }
      }
    },
    submitDialogForm(){
      this.$refs[this.dialogRefName].validate((valid) => {
        if (valid) {
          this.$confirm("确定提交数据么?")
              .then(_ => {
                  this.updateData();
                //取消新增或修改也要重置表单
              }).catch(err => {this.handleCloseDialog();});
        } else {
          return false;
        }
      });
    },
    handlePageSizeChange(val){
      this.pagination.pageSize = val;
      this.submitQueryForm()
    },
    handlePageNumChange(val){
      this.pagination.pageNum = val;
      this.submitQueryForm()
      //切换页面恢复到顶部
      this.scrollTop = 0
      this.saveScroll()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  margin-top: 20px;
  .el-form-item {
    margin-bottom: 10px;
  }
}

</style>
